import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';
import { ModalProvider as StyledModalProvider } from 'styled-react-modal';
import { GlobalStyles } from '../../../global.styles';
import { ModalBlurredBackground } from '../../common/blurred-background/blurred-background.styles';
import { ModalProvider, ModalRoot } from '../../common/modal';
import PageLoader from '../../common/page-loader/page-loader.component';
import { WidgetCalculatorFrameWrapper } from '../../features/main/widget-calculator/widget-calculator.styles';
import { useInitLocale } from '../../hooks/use-init-locale';
import { useStore } from '../../stores/store';

const CalculatorIframeLayout = () => {
  const {
    commonStore: {
      analyticsManager,
      setAnalyticsInitialized,
      setIsGuestParcelCreation,
    },
    localizationsStore: {
      fetchCountries,
      languageCode,
      selectedCountry,
      selectedLocalization,
    },
    shipmentCountriesStore: { loadDirectionsList },
  } = useStore();

  useInitLocale();

  useEffect(() => {
    setIsGuestParcelCreation(true);
    fetchCountries();

    return () => setIsGuestParcelCreation(false);
  }, [fetchCountries, setIsGuestParcelCreation]);

  useEffect(() => {
    if (!selectedCountry || !selectedLocalization) return;

    loadDirectionsList();
  }, [loadDirectionsList, selectedCountry, selectedLocalization]);

  useEffect(() => {
    if (!selectedCountry?.country_code) return;

    analyticsManager.initialize();
    setAnalyticsInitialized(true);
  }, [
    analyticsManager,
    selectedCountry?.country_code,
    setAnalyticsInitialized,
  ]);

  useEffect(() => {
    document.documentElement.lang = languageCode;
  }, [languageCode]);

  useEffect(() => {
    document.getElementById('flag-emoji-font-stylesheet')?.remove();
  }, []);

  if (!selectedCountry || !selectedLocalization) return <PageLoader />;

  return (
    <WidgetCalculatorFrameWrapper>
      <GlobalStyles />
      <StyledModalProvider backgroundComponent={ModalBlurredBackground}>
        <ModalProvider>
          <Outlet />
          <ModalRoot />
        </ModalProvider>
      </StyledModalProvider>
    </WidgetCalculatorFrameWrapper>
  );
};

export default observer(CalculatorIframeLayout);
